import React from 'react'
import GroupSelect from './GroupSelect'
import Suggestions from './Suggestions'
import language from 'utils/vast-languagepack'

export default () => (
  <div>
    <div style={{ margin: '5px 0 20px 2px', fontSize: 12 }}>
      {language.contacts.add.helperText.groupDescription}
    </div>
    <GroupSelect />
    <Suggestions />
  </div>
)